import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/operator/map';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { IssueService } from '../../../issue/service/issue.service';
import { AuthService } from '../../../security/service/auth.service';
import { FormElementChoicePriorityModel } from '../../model/form-element-choice-priority.model';
import { IssueRelatedQuestionModel } from '../../model/issue.related.question.model';
import { QuestionUIMessages } from '../../model/question-ui.messages';
import { QuestionModel } from '../../model/question.model';
import { QuestionChoiceModel } from '../../model/questionChoice.model';
import { QuestionService } from '../../service/question.service';

@Component({
  selector: 'edit-question-choice',
  templateUrl:
    'console/app-js/modules/question/components/edit-question-choice/edit-question-choice.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EditQuestionChoiceComponent extends APIOperableComponent
  implements OnInit, OnDestroy {
  public issueId: string;
  public date;
  protected formElementChoices: QuestionChoiceModel;
  protected impactData: Array<any> = [
    {
      id: 'NoImpact',
      value: 'No Impact'
    },
    {
      id: 'Priority',
      value: 'Priority'
    },
    {
      id: 'Documentation',
      value: 'Documentation'
    }
  ];
  protected defaultPriority = {
    value: 'Select Priority...'
  };
  public choicesMinimum = false;
  protected selectedQuestionChioce: any;
  protected defaultImpact: any = this.impactData[0];
  @Input() que: QuestionModel;
  @Input() questionData: IssueRelatedQuestionModel;
  protected cloneQuestionData: IssueRelatedQuestionModel;
  protected cancelActiveQuestionData: Array<QuestionModel>;
  @Input() firstElementId: string;
  @Input() lastElementId: string;
  @Input() activeQuestionData: Array<QuestionModel>;
  @Output('close') close = new EventEmitter<any>();
  @Output('reorder') reorder = new EventEmitter<any>();
  @Input() element: QuestionModel;
  @Input() addNewFlg: boolean;
  @Input() priorities: any;
  @ViewChild('templateForm', { static: true }) templateForm: NgForm;
  protected saveInProgress = false;
  protected currentElementId: string;
  protected reOrderFlag = false;
  protected cancelFlag = false;
  protected selectedCustomer: string;
  protected selectedPriority: any;
  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private questionService: QuestionService,
    private issueService: IssueService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit(): void {
    this.selectedCustomer = localStorage.getItem('cNum');
    this.cloneQuestionData = JSON.parse(JSON.stringify(this.questionData));
    if (!this.activeQuestionData) {
      this.activeQuestionData = JSON.parse(
        JSON.stringify(this.questionData.elements)
      ).filter(question => question.isActive);
    }
    if (!this.cancelActiveQuestionData) {
      this.cancelActiveQuestionData = JSON.parse(
        JSON.stringify(this.questionData.elements)
      ).filter(question => question.isActive);
    }
    if (this.element !== undefined) {
      this.cloneQuestionData.elements.push(this.element);
      this.element = undefined;
    }
    this.currentElementId = this.que.id;
    this.issueId = this.cloneQuestionData.issueId;
    this.cloneQuestionData.elements.forEach(question => {
      if (question.id === this.que.id) {
        this.que = question;
      }
      // Mapping of ImpactID with Dropdown object Id
      question.formElementChoices.forEach(ch => {
        ch['impactObj'] = {};
        ch['priorityObj'] = {};
        this.impactData.forEach(im => {
          if (im.id === ch.impact) {
            ch['impactObj'].id = im.id;
            ch['impactObj'].value = im.value;
          }
        });
        ch.formElementChoicePriority.forEach(fecp => {
          this.priorities.forEach(priorityData => {
            if (
              fecp.priority.customerNumber === this.selectedCustomer &&
              fecp.priority.name === priorityData.value
            ) {
              ch['priorityObj'].id = priorityData.id;
              ch['priorityObj'].value = priorityData.value;
            }
          });
        });
      });
    });
  }

  rollBackToInitialState() {
    this.activeQuestionData = this.cancelActiveQuestionData;
  }

  ngOnDestroy(): void {
    this.rollBackToInitialState();
    this.cancelFlag = false;
    this.reOrderFlag = false;
    this.cancelActiveQuestionData = null;
    this.firstElementId = null;
    this.lastElementId = null;
  }

  /**
   * Method to  delete choice when user click on "Delete" buttons
   */
  deleteChoice(
    questionModel: QuestionModel,
    choice: QuestionChoiceModel
  ): void {
    this.cloneQuestionData.elements.forEach(question => {
      if (question.id === questionModel.id) {
        question.formElementChoices.forEach(ch => {
          if (ch.id === choice.id) {
            const index: number = question.formElementChoices.indexOf(ch);
            question.formElementChoices.splice(index, 1);
          }
        });
      }
    });
    this.checkForMinimumChoices(questionModel);
  }

  /**
   * Method to add choice based on user click on "ADD Choice" buttons
   */
  addChoice(que: QuestionModel): void {
    this.cloneQuestionData.elements.forEach(question => {
      if (question.id === que.id) {
        let id = Math.floor(Math.random() * 600) + 1;
        let addch: QuestionChoiceModel = new QuestionChoiceModel();
        addch.id = id + 'Custom_ID';
        addch.impact = 'NoImpact';
        question.formElementChoices.push(addch);
      }
    });
    this.checkForMinimumChoices(que);
  }

  /**
   * Method to check if there are minimum two choices
   */
  checkForMinimumChoices(question: QuestionModel): void {
    if (question.formElementChoices.length < 2) {
      this.choicesMinimum = true;
    } else {
      this.choicesMinimum = false;
    }
  }

  /**
   * On Selection change of impact dropdown
   */
  selectionChange(event, ch: any): void {
    if (event) {
      this.cloneQuestionData.elements.forEach(question => {
        question.formElementChoices.forEach(choice => {
          if (choice.id === ch.id) {
            choice.impact = event.id;
          }
        });
      });
    }
  }

  /**
   * Method check for duplicate questions
   */
  public checkDuplicate(questionEdit: any): void {
    const tempActiveData = JSON.parse(JSON.stringify(this.activeQuestionData));
    tempActiveData.forEach(question => {
      if (
        question.text.toLowerCase().trim() ===
          questionEdit.text.toLowerCase().trim() &&
        questionEdit.id !== question.id
      ) {
        this.templateForm.controls['question'].setErrors({ duplicate: true });
      } else if (
        !this.templateForm.controls['question'].hasError('duplicate')
      ) {
        this.templateForm.controls['question'].setErrors(null);
        // only way to set template form error to false is to set all errors on that control to false
        // because of this need to check for required error again
      }
    });
  }

  /**
   * Method check for whitespeace
   */
  public checkWhiteSpace(text: string, control: any): void {
    if (text && text.trim() === '') {
      control.setErrors({ required: true });
    }
  }

  /**
   * Method to save data. This method need to integrate with save API
   */
  onSave(que: QuestionModel, actions: string): void {
    if (
      ((this.templateForm.valid && !this.choicesMinimum) ||
        actions === 'Delete') &&
      !this.saveInProgress
    ) {
      this.saveInProgress = true;
      this.startProgress(); // START PROGRESS
      // re-order flag is set
      if (this.reOrderFlag === true) {
        this.reOrderFlag = false;
        this.cloneQuestionData.elements.forEach(question => {
          this.activeQuestionData.forEach(elem => {
            if (elem.id === question.id) {
              Object.assign(question, elem);
            } // The indexed order is ready here for the Save operation to happen next
          });
        });
      }
      let tempUpsertForm = JSON.parse(JSON.stringify(this.cloneQuestionData));
      //  editing an existing question
      tempUpsertForm.elements.forEach(question => {
        if (question.id === que.id) {
          question = JSON.parse(JSON.stringify(que));
        }
      });
      //  adding a new question
      tempUpsertForm.elements.forEach(question => {
        if (que.id.toString().includes('Custom_ID') && question.id === que.id) {
          question.id = null;
        }
        question.formElementChoices.forEach((choice, index) => {
          choice.orderIndex = index + 1;
          choice.id = choice.id.toString().includes('Custom_ID')
            ? null
            : choice.id;
          delete choice.impactObj;
          delete choice.priorityObj;
        });
      });
      this.questionService.upsertQuestions(tempUpsertForm).subscribe(
        res => {
          if (!res.errors && !res.error) {
            this.issueService
              .refreshIssueMetaData(tempUpsertForm.issueId)
              .subscribe();
            if (actions === 'Save') {
              this.onAPISuccess(QuestionUIMessages.EDIT_QUESTION_SUCCESS);
            } else if (actions === 'Delete') {
              this.onAPISuccess(QuestionUIMessages.DELETE_QUESTION_SUCCESS);
            }
            this.saveInProgress = false;
            this.close.emit({ action: actions, question: this.que });
            this.finishProgress();
          } else {
            this.saveInProgress = false;
            this.onAPIError(QuestionUIMessages.EDIT_QUESTION_ERROR);
          }
        },
        err => {
          this.saveInProgress = false;
          this.onAPIError(QuestionUIMessages.EDIT_QUESTION_ERROR);
        }
      );
    }
  }

  /**
   * Method to Update data. This method need to integrate with save API
   */
  onUpdate(que: QuestionModel, actions: string): void {
    if (
      ((this.templateForm.valid && !this.choicesMinimum) ||
        actions === 'Delete') &&
      !this.saveInProgress
    ) {
      this.saveInProgress = true;
      this.startProgress(); // START PROGRESS
      // Take in the Edited values
      this.activeQuestionData.forEach(elem => {
        if (elem.id === que.id) {
          // Object.assign(elem, que);
          elem.text = que.text;
          Object.assign(elem.formElementChoices, que.formElementChoices);
        }
      });
      // re-order flag is set
      if (this.reOrderFlag === true) {
        this.reOrderFlag = false;
        this.cloneQuestionData.elements.forEach(question => {
          this.activeQuestionData.forEach(elem => {
            if (elem.id === question.id) {
              Object.assign(question, elem);
            } // The indexed order is ready here for the Save operation to happen next
          });
        });
      }
      // Remove the custom_ID if present
      const found = this.cloneQuestionData.elements.find(ques => {
        return ques.id.toString().includes('Custom_ID');
      });
      if (found) {
        const index: number = this.cloneQuestionData.elements.indexOf(found);
        this.cloneQuestionData.elements.splice(index, 1);
      }
      let tempUpsertForm = JSON.parse(JSON.stringify(this.cloneQuestionData));
      tempUpsertForm.elements.forEach(question => {
        if (question.id === que.id) {
          question = JSON.parse(JSON.stringify(que));
        }
      });
      //  remove extra data: impactObj
      tempUpsertForm.elements.forEach(question => {
        question.formElementChoices.forEach((choice, index) => {
          choice.orderIndex = index + 1;
          choice.id = choice.id.toString().includes('Custom_ID')
            ? null
            : choice.id;
          delete choice.impactObj;
          delete choice.priorityObj;
        });
      });
      this.questionService.upsertQuestions(tempUpsertForm).subscribe(
        res => {
          if (!res.errors && !res.error) {
            this.issueService
              .refreshIssueMetaData(tempUpsertForm.issueId)
              .subscribe();
            if (actions === 'Update') {
              this.onAPISuccess(QuestionUIMessages.UPDATE_QUESTION_SUCCESS);
            } else if (actions === 'Delete') {
              this.onAPISuccess(QuestionUIMessages.DELETE_QUESTION_SUCCESS);
            }
            this.saveInProgress = false;
            this.close.emit({ action: actions, question: this.que });
            this.finishProgress();
          } else {
            this.saveInProgress = false;
            this.onAPIError(QuestionUIMessages.UPDATE_QUESTION_ERROR);
          }
        },
        err => {
          this.saveInProgress = false;
          this.onAPIError(QuestionUIMessages.UPDATE_QUESTION_ERROR);
        }
      );
    }
  }

  onCancel(newQuestion: QuestionModel): void {
    this.cancelFlag = true;
    this.reOrderFlag = false;
    // Remove the custom_ID if present
    const found = this.activeQuestionData.find(ques => {
      return ques.id.toString().includes('Custom_ID');
    });
    if (found) {
      const index: number = this.activeQuestionData.indexOf(found);
      this.activeQuestionData.splice(index, 1);
    }
    // Take the one-to-one moving of initial object to activeQuestionData
    this.cancelActiveQuestionData.forEach(elem => {
      this.activeQuestionData.forEach(orig => {
        if (elem.id === orig.id) {
          Object.assign(orig, elem);
        }
      });
    });
    // arrange per the new orderIndex.
    this.activeQuestionData = this.activeQuestionData.sort(
      (a, b) => a.orderIndex - b.orderIndex
    );
    this.close.emit({
      action: 'Cancel',
      reIndexedElements: this.activeQuestionData,
      firstElement: this.activeQuestionData[0].id,
      lastElement: this.activeQuestionData[this.activeQuestionData.length - 1]
        .id
    });
  }

  /**
   * Displays out a popup confirmation dialog for deleting the selected question from list.
   */
  onDeleteQuestion(ques: QuestionModel): void {
    if (!ques.id.toString().includes('Custom_ID')) {
      let confirmationMessage = QuestionUIMessages.DELETE_QUESTION_CONFIRMATION;
      this.dialogService
        .open(ConfirmationComponent, [
          {
            provide: ConfirmationModel,
            useValue: new ConfirmationModel(
              QuestionUIMessages.DELETE_QUESTION_TITLE,
              confirmationMessage
            )
          }
        ])
        .then(confirmed => {
          if (confirmed) {
            let foundQues = this.cloneQuestionData.elements.find(question => {
              return question.id === ques.id;
            });
            if (foundQues) {
              foundQues.isActive = false;
            }
            this.onSave(ques, 'Delete');
          }
        });
    }
  }

  /**
   * Method to trigger re-order of Index data.
   * This method will manipulate the activeQuestionData elements orderIndex
   * Finally emit an event to parent to handle the question element re-order
   * The ngx-order-pipe handles the positional rendering on UI
   *
   * @param: Numeric elementId - the element being re-ordered
   * @param: String move Type - 'up' OR 'down'
   */
  onMoveOrderIndex(triggerElement: QuestionModel, movementType: string): void {
    this.reOrderFlag = true;

    let elementsLength = this.activeQuestionData.length;
    let triggerPosition = -1;
    triggerPosition = this.activeQuestionData.findIndex(
      elem => elem.id === triggerElement.id
    );
    let initialOrderIndex = this.activeQuestionData[triggerPosition].orderIndex;
    let destPosition = 0;
    let destOrderIndex = 0;
    //  Determine the indices
    if (movementType === 'down') {
      destPosition =
        triggerPosition + 1 === elementsLength
          ? elementsLength
          : triggerPosition + 1;
      destOrderIndex = this.activeQuestionData[destPosition].orderIndex;
    } else if (movementType === 'up') {
      destPosition = triggerPosition - 1 < 0 ? 0 : triggerPosition - 1;
      if (destPosition !== 0) {
        destOrderIndex = this.activeQuestionData[destPosition].orderIndex;
      } else {
        destOrderIndex = this.activeQuestionData[0].orderIndex;
      }
    }
    this.activeQuestionData[triggerPosition].orderIndex = destOrderIndex;
    this.activeQuestionData[destPosition].orderIndex = initialOrderIndex;
    // arrange per the new orderIndex.
    this.activeQuestionData = this.activeQuestionData.sort(
      (a, b) => a.orderIndex - b.orderIndex
    );
    this.firstElementId = this.activeQuestionData[0].id;
    this.lastElementId = this.activeQuestionData[elementsLength - 1].id;
    triggerPosition = null;
    destPosition = null;
    initialOrderIndex = null;
    destOrderIndex = null;
    triggerElement = null;
    movementType = null;
    // // Emit the re-ordered Object to Parent
    this.reorder.emit({
      action: 'Reorder',
      reIndexedElements: this.activeQuestionData,
      firstElement: this.firstElementId,
      lastElement: this.lastElementId
    });
  }

  swapIndices(
    triggerPosition: number,
    destPosition: number,
    initialOrderIndex: number,
    destOrderIndex: number
  ) {
    this.activeQuestionData[triggerPosition].orderIndex = destOrderIndex;
    this.activeQuestionData[destPosition].orderIndex = initialOrderIndex;
  }

  /**
   * Method to add show priority dropdown based on customerNumber and priority selection
   */
  prioritySelected(priorities: any, ch: any): boolean {
    if (
      this.selectedCustomer &&
      ch.impact !== undefined &&
      ch.impact === 'Priority'
    ) {
      if (priorities) {
        this.selectedPriority = priorities.filter(
          priority => priority.customerNumber === this.selectedCustomer
        );
      }
      return true;
    } else {
      return false;
    }
  }

  /**
   * On Selection change of priority dropdown
   */
  prioritySelectionChange(event, ch: any): void {
    if (event) {
      this.cloneQuestionData.elements.forEach(question => {
        question.formElementChoices.forEach(choice => {
          if (choice.id === ch.id) {
            if (event.value !== 'Select Priority...') {
              if (
                choice.formElementChoicePriority !== undefined &&
                choice.formElementChoicePriority.length > 0
              ) {
                choice.formElementChoicePriority.forEach(fecp => {
                  if (fecp.priority.customerNumber === this.selectedCustomer) {
                    fecp.priority.name = event.value;
                  } else {
                    choice.formElementChoicePriority.push(
                      this.createNewFECP(event)
                    );
                  }
                });
              } else {
                choice.formElementChoicePriority.push(
                  this.createNewFECP(event)
                );
              }
            } else {
              for (
                let i = 0;
                i < choice.formElementChoicePriority.length;
                i++
              ) {
                if (
                  choice.formElementChoicePriority[i].priority
                    .customerNumber === this.selectedCustomer
                ) {
                  choice.formElementChoicePriority.splice(i, 1);
                  i--;
                }
              }
            }
          }
        });
      });
    }
  }

  createNewFECP(event): FormElementChoicePriorityModel {
    let newFECP = new FormElementChoicePriorityModel();
    newFECP.priority.customerNumber = this.selectedCustomer;
    newFECP.priority.name = event.value;
    return newFECP;
  }
}
